<template>
  <div>
    <!-- {{ perm }} -->
    <v-card-title>
      <router-link
        :exact="true"
        :to="{ name: 'AddCallData' }"
        active-class=""
        class="profile-link"
      >
        <v-btn color="#6A158E" dark>+ Add Data</v-btn>
      </router-link>

      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :loading="loading"
      :search="search"
      :items="items"
      :headers="headers"
    >
      <template v-slot:[`item.id`]="{ item }">
        {{ item.id }}
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-btn @click="showDialog(item)" small>
          <!-- <v-icon dark>mdi-plus</v-icon> -->
          Add Details
        </v-btn>
      </template>
      <template v-slot:[`item.delete`]="{ item }">
        <router-link :disabled="perm.edit" :event="perm.edit ? 'click': ''"
          class="profile-link"
          active-class
          :exact="true"
          :to="{ name: 'EditCallData', params: { id: item.id } }"
        >
          <v-icon :disabled="!perm.edit" color="success">mdi-file-edit</v-icon>
        </router-link>
        <v-icon :disabled="!perm.delete"  color="red" @click="confirmDelete(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>

    <v-overlay :value="overlay" style="z-index: 99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <delete-dialog
      @success="deleteGroup"
      :confirm-loading="deleteConfirmLoading"
      @closeDialog="cancelDelete"
      :dialog="delete_dialog"
      title="Group"
    ></delete-dialog>
  </div>
</template>

<script>
// import DiscountDialog from "./DiscountDialog";
// import TutorAssignmentForm from "./TutorAssignmentForm";
import DataTableMixin from "../../mixins/dataTable";
import Form from "../../utils/form";
import DeleteDialog from "../Dialogs/DeleteDialog";
import DeleteRow from "../../mixins/deleteRow";

export default {
  props: ['perm'],
  name: "ReceivedCallTable",
  components: {
    DeleteDialog,
  },
  mixins: [DataTableMixin, DeleteRow],
  data() {
    return {
      search: "",
      overlay: false,
      errors: {},
      data: {},
      menu1: false,
      menu2: false,
      menu3: false,
      dialog: false,
      dialog2: false,
      student_id: "",
      classes: [],
      selectedClass: "",
      currentRow: 0,
      loading: true,
      discount_dialog: false,
      tutor_assign_dialog: false,
      page: 1,
      pageCount: 3,
      itemsPerPage: 10,
      headers: [
        // { text: "SRNO", sortable: true, value: "id" },
        {
          text: "Id",
          sortable: true,
          value: "id",
        },
        {
          text: "Full Name",
          value: "fname",
          sortable: true,
        },

        {
          text: "Phone Number",
          value: "contact_no",
          sortable: true,
        },
        {
          text: "Email",
          value: "email",
          sortable: true,
        },

        {
          text: "Action",
          value: "delete",
          sortable: true,
        },
      ],
    };
  },
  methods: {
    deleteGroup() {
      // console.log(this.current_row);
      axios
        .delete(apiRoutes.AddCallData.url + "/" + this.current_row.id)
        .then((response) => {
          // this.getItems()
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
          this.getItems();
        })
        .catch((error) => {
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
          // Toast.fire({
          //     icon: 'error',
          //     title: 'Cannot Deleted Linked Groups!',
          // })
        });
    },
    cancelDelete() {
      this.deleteConfirmLoading = false;
      this.delete_dialog = false;
    },
    setUsername() {
      let form = new Form({
        ...this.data,
      });
      this.overlay = true;
      form
        .post("set/username")
        .then((response) => {
          console.log(response);
          // this.formalizeTable(response.data);
          this.dialog2 = false;
          this.getItems();
          this.overlay = false;

          // console.log(response)
          // this.classes = response.data.response
        })
        .catch((response) => {
          this.overlay = false;

          console.log(response);
          if (response.status === 400) {
            this.errors = response.data;
          }
          // alert(response.status)
          if (response.status === 422) {
            //    console.log(response.data)
            this.errors = response.data.errors;
          }
          this.loading = false;
        });
    },
    chooseCLass() {
      // var data = {
      //   "student_id" : this.student_id,
      //   "class_id" : this.selectedClass
      // }
      axios.post("select/class", this.data).then((response) => {
        // this.formalizeTable(response.data);
        this.dialog = false;
        this.getItems();
        // console.log(response)
        // this.classes = response.data.response
      });
    },
    showDialog2(item) {
      this.data.student_id = item.std_id;
      this.dialog2 = true;
    },
    showDialog(item) {
      console.log(item);
      this.dialog = true;
      axios.get("classes").then((response) => {
        // this.formalizeTable(response.data);
        // this.loading = false;
        console.log(response);
        this.classes = response.data.response;
        this.data.student_id = item.std_id;
        this.data.joining_date = item.std_joining_date;
        this.data.ending_date = item.std_leaving_date;
        this.data.date_of_birth = item.std_dob;
        this.data.number_of_hours = item.std_no_of_hours;
        this.data.selected_class = parseInt(item.class_id);
      });
    },
    getItems() {
      axios.get(apiRoutes.AddCallData.url).then((response) => {
        // this.formalizeTable(response.data);
        this.items = response.data.response;

        this.loading = false;
      });
    },
    addDiscount(item) {
      this.currentRow = item.user_id;
      this.discount_dialog = !this.discount_dialog;
    },
    cancelDiscount() {
      this.currentRow = 0;
      this.discount_dialog = !this.discount_dialog;
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>

<style scoped>
</style>
